<template>
  <div :class="['gift-card-wrapper', statusBg]">
    <div class="gift-card-header">
      <i class="brand-icon" :style="{backgroundImage: giftCardData.store_logo && `url(${giftCardData.store_logo})`}"></i>
      <div class="titles">
        <span class="main-title">{{giftCardData.title}}</span>
        <span class="sub-title">NO.{{giftCardData.card_no}}</span>
      </div>
      <span class="sperate-space"></span>
      <div class="gift-card-header__right">
        <div class="plate">{{giftCardData.plate_number}}</div>
        <div class="vin">{{giftCardData.vin}}</div>
      </div>
    </div>
    <div class="gift-card-body">
      <div class="gift-card-content">
        <div class="gift-card-total">
          <span>面值</span>
          <span class="total-price">{{giftCardData.face_value | formatPrice}}</span>
          元
        </div>
        <div class="gift-card-line"></div>
        <div class="gift-card-leave">
          <span>余额</span>
          <span>{{giftCardData.balance | formatPrice}}元</span>
        </div>
      </div>
    </div>
    <div class="gift-card-footer">
      <span class="validity">有效期：{{giftCardData.effective_at}} 至 {{giftCardData.expired_at}}</span>
      <span class="highest-consumption" v-if="giftCardData.quota > 0">
        最高{{giftCardData.quota | formatPrice }}元/次
      </span>
      <!-- <i class="RQ-code"></i> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          // store_logo: '../../stylesheets/images/default-logo.png',
          title: '全额保费返现卡',
          card_no: 'NO.236867688',
          plate_number: '粤B12345',
          face_value: '100000',
          balance: '90000',
          create_at: '2018-3-24',
          expired_at: ' 2018-5-28',
          is_canceled: false,
          is_expired: false
        }
      }
    }
  },
  data() {
    return {}
  },
  filters: {
    formatPrice(price) {
      const val = (price / 100).toFixed(2)
      const arr = (val + '').split('.')
      if (arr[1] === '00') {
        return parseInt(arr[0], 10)
      }
      return val
    }
  },
  computed: {
    statusBg() {
      return this.giftCardData.is_canceled
        ? 'calceled-bg'// 作废
        : this.giftCardData.is_expired
          ? 'expired-bg'// 过期
          : 'normal-bg'// 正常
    },
    giftCardData() {
      const defaultData = {
        // store_logo: '/static/img/default-logo.png',
        title: '全额保费返现卡',
        card_no: '236867688',
        plate_number: '粤B12345',
        face_value: '100000',
        balance: '90000',
        create_at: '2018-3-24',
        expired_at: ' 2018-5-28',
        is_canceled: true,
        is_expired: false
      }
      return { ...defaultData, ...this.cardData }
    }
  }
}
</script>

<style lang="less" scoped>

.gift-card-wrapper {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin-bottom: .5rem;
  padding: .4rem;
  width: 9.2rem;
  height: 5.16rem;
  line-height: 1;
  box-shadow: 0rem 0.03rem 0.23rem 0.01rem rgba(88, 144, 254, 0.42);
  border-radius: 0.21rem;
  background-position: center;
  background-size: cover;

  &.normal-bg {
    background-image: url(../../stylesheets/images/normal-bg.png);
  }

  &.calceled-bg {
    background-image: url(../../stylesheets/images/canceled-bg.png);
  }

  &.expired-bg {
    background-image: url(../../stylesheets/images/expired-bg.png);
  }

  .gift-card-header {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 0.84rem;
  }
}

.gift-card-header {
  .brand-icon {
    margin-right: .27rem;
    width: 0.84rem;
    height: 0.84rem;
    border-radius: 50%;
    background-image: url(../../stylesheets/images/default-logo.png);
    background-repeat: no-repeat;
    background-size: contain;
    // background-position: center;
  }

  .titles {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .main-title {
      font-size: 0.4rem;
      color: #ffffff;
    }

    .sub-title {
      font-size: 0.29rem;
      color: rgba(255, 255, 255, 0.5);
    }
  }

  .sperate-space {
    flex: 1;
  }

  &__right {
    text-align: right;
  }

  .plate, .vin {
    font-size: 0.29rem;
    color: rgba(255, 255, 255, 0.5);
  }
  .plate {
    margin-top: 0.05rem;
  }
  .vin {
    margin-top: 0.18rem;
  }
}

.gift-card-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .gift-card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 1.2rem;
    color: #ffffff;
    font-size: 0.29rem;

    .gift-card-total {
      box-sizing: border-box;
      height: 0.56rem;

      .total-price {
        font-size: .67rem;
        margin-left: .23rem;
        margin-right:  .08rem;
      }
    }

    .gift-card-line {
      width: 100%;
      height: 0.03rem;
      background-color: rgba(255, 255, 255, 0.5);
      opacity: 0.5;
    }

    .gift-card-leave {
      display: flex;
      justify-content: space-between;
    }
  }
}

.gift-card-footer {
  display: flex;
  justify-content: space-between;
  span {
    display: block;
    font-size: 0.29rem;
    color: #fff;
  }

  .validity {
    align-self: flex-end;
  }
  .highest-consumption {
    padding-right: 0.6rem;
  }

  .RQ-code {
    width: 0.43rem;
    height: 0.43rem;
    margin-bottom: -0.05rem;
    background-color: rgba(0, 0, 0, 0);
  }
}
</style>
